/* RealBio — comportamientos del tema. Sin dependencias. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     Índice del artículo: resalta la sección visible.
     Los enlaces y los id ya vienen del servidor (Liquid), así que esto solo
     añade el resaltado — si el JS falla, el índice sigue funcionando.
     --------------------------------------------------------------------- */
  function initToc() {
    var toc = document.querySelector('.rb-toc');
    var prose = document.querySelector('.rb-article__prose');
    if (!toc || !prose) return;

    var headings = prose.querySelectorAll('h2[id]');
    if (headings.length < 2) return;

    var links = {};
    toc.querySelectorAll('a[href^="#"]').forEach(function (a) {
      links[a.getAttribute('href').slice(1)] = a;
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var link = links[entry.target.id];
          if (!link) return;
          if (entry.isIntersecting) {
            Object.keys(links).forEach(function (k) {
              links[k].classList.remove('is-active');
            });
            link.classList.add('is-active');
          }
        });
      },
      { rootMargin: '-10% 0px -75% 0px' }
    );

    headings.forEach(function (h) {
      observer.observe(h);
    });
  }

  /* ---------------------------------------------------------------------
     Tablas anchas: envolverlas para que scrolleen solas en móvil en vez de
     desbordar la página. El editor de Shopify no puede añadir el wrapper.
     --------------------------------------------------------------------- */
  function wrapTables() {
    document.querySelectorAll('.rb-article__prose table').forEach(function (table) {
      if (table.parentElement.classList.contains('rb-scroll-x')) return;
      var wrap = document.createElement('div');
      wrap.className = 'rb-scroll-x';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  /* ---------------------------------------------------------------------
     Reveal al entrar en pantalla.
     Failsafe: si el observer no dispara (pasa dentro de iframes de preview y
     en webviews de anuncios), revelamos todo. Nunca dejar la página en blanco.
     --------------------------------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('.rb-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });

    window.setTimeout(function () {
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 1200);
  }

  function init() {
    initToc();
    wrapTables();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* ------------------------------------------------------------------
   Galería de producto.
   Progresivo a propósito: el HTML llega con todas las tomas apiladas y
   visibles. La clase is-ready sólo la pone este script, así que si el JS
   falla el usuario sigue viendo las 5 imágenes en vez de ninguna.
------------------------------------------------------------------ */
(function () {
  function initGaleria(gal) {
    var slides = gal.querySelectorAll('[data-gal-slide]');
    var thumbs = gal.querySelectorAll('[data-gal-thumb]');
    if (slides.length < 2 || !thumbs.length) return;

    gal.classList.add('is-ready');

    function mostrar(i) {
      slides.forEach(function (s) {
        s.classList.toggle('is-on', s.dataset.galSlide === String(i));
      });
      thumbs.forEach(function (t) {
        var on = t.dataset.galThumb === String(i);
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        mostrar(t.dataset.galThumb);
      });
    });

    // Flechas para recorrer la galería con el teclado.
    gal.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var actual = 0;
      thumbs.forEach(function (t, i) {
        if (t.classList.contains('is-on')) actual = i;
      });
      var siguiente = e.key === 'ArrowRight'
        ? (actual + 1) % thumbs.length
        : (actual - 1 + thumbs.length) % thumbs.length;
      e.preventDefault();
      mostrar(siguiente);
      thumbs[siguiente].focus();
    });
  }

  function init() {
    document.querySelectorAll('[data-rb-gal]').forEach(initGaleria);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* ------------------------------------------------------------------
   Reproductor del comercial.
   El <video> no existe en el HTML: se crea al pulsar. Así el navegador
   no toca el CDN de vídeo (10 MB) mientras el usuario lee la página, y
   el LCP no se resiente. Sin autoplay a propósito: lleva locución.
------------------------------------------------------------------ */
(function () {
  function initVideo(box) {
    var boton = box.querySelector('.rb-vid__play');
    var src = box.dataset.src;
    if (!boton || !src) return;

    boton.addEventListener('click', function () {
      if (box.classList.contains('is-playing')) return;

      var v = document.createElement('video');
      v.src = src;
      v.controls = true;
      v.playsInline = true;
      v.preload = 'auto';
      if (box.dataset.poster) v.poster = box.dataset.poster;

      box.appendChild(v);
      box.classList.add('is-playing');
      v.play().catch(function () {
        // Si el navegador bloquea la reproducción, los controles siguen ahí.
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-rb-video]').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
